/*
 * CONFIRM VAT RELIEF
 * Opens modal when the "add the cart" button is clicked on the product page.
 */
function confirmVatRelief(el) {
  const form = el.closest("form");
  const vatModal = document.querySelector('#formVatRelief');
  let variants = getVariants();
  let variant = variants.variant;
  let inclusiveVariant = variants.inclusiveVariant;

  // Show the modal (if related cart attributes are not set).
  if (showVatModal == true) {
    vatModal.querySelector("#formVatNo").value = variant.id;
    vatModal.querySelector("#formVatYes").value = inclusiveVariant.id;
    vatModal.querySelector("#js__formVatQty").value = (document.querySelector('.quantity__input')) ? document.querySelector('.quantity__input').value : 1;
    document.querySelector("#formVatRelief").showModal();
  } else {
    // Else, add the item directly to the cart because we already have
    // the customer's vat status.
    form.querySelector('input[name="id"]').value = variant.id;
    form.submit();
  }
}


/*
 * GET VARIANTS
 * Returns variant and inclusive variant.
 */
function getVariants() {
  let variant = null;
  let inclusiveVariant = null;
  let exclusiveVariant = null;
  let options = [];
  options[1] = null;
  options[2] = null;
  options[3] = null;

  // Get the variant options to set search product variants with.
  document.querySelectorAll('.js--variant-option').forEach(function(el) {
    if (el.tagName.toLowerCase() == 'input' && el.checked == true || el.classList.contains('js--vat-option')) {
      let option = el.name.replace('option', '');
      let optionValue = el.value;
      options[option] = optionValue;
    }
  });
  let inclusive = options;
  let exclusive = options;

  // Get the default exclusive variant. Exclusive will only be the default if
  // the customer hasn't checked a VAT preference. If they have, `variant` will
  // contain the inclusive or exclusive value based on their saved preference.
  // Important: This object will contain the variant ID to pass to cart.
  for (let i = 0; i < productVariants.length; i++) {
    if (productVariants[i].option1 == options[1] &&
      productVariants[i].option2 == options[2] &&
      productVariants[i].option3 == options[3]) {
      variant = productVariants[i];
      break;
    }
  };

  // Get the actual exclusive variant.
  exclusive[vatOptionField] = vatOptionValues.exclusive;
  for (let i = 0; i < productVariants.length; i++) {
    if (productVariants[i].option1 == exclusive[1] &&
      productVariants[i].option2 == exclusive[2] &&
      productVariants[i].option3 == exclusive[3]) {
      exclusiveVariant = productVariants[i];
      break;
    }
  };

  // Get the actual inclusive variant.
  inclusive[vatOptionField] = vatOptionValues.inclusive;
  for (let i = 0; i < productVariants.length; i++) {
    if (productVariants[i].option1 == inclusive[1] &&
      productVariants[i].option2 == inclusive[2] &&
      productVariants[i].option3 == inclusive[3]) {
      inclusiveVariant = productVariants[i];
      break;
    }
  };

  return {
    variant: variant,
    exclusiveVariant: exclusiveVariant,
    inclusiveVariant: inclusiveVariant,
  }
}

/*
 * CHECK AVAILABILITY
 * Checks the variant availability of selected options and disables the buy
 * button if applicable.
 */
function variantAvailability() {
  let items = getVariants();
  let btn = document.querySelector('.product-form__submit');
  let sku = document.querySelector('.product__sku');
  let availability = false;

  // BEGIN: Strike through variant options that do not exist.
  let $this = event.target;
  if ($this !== undefined) {
    let availableVariants = new Set();
    productVariants.filter(function(variant, k) {
      if (variant[$this.name] == $this.value) {
        availableVariants.add(variant);
      }
    });

    // Loop through the array above to create an array containing available
    // option values.
    let optionGroups = {};
    availableVariants.forEach(function(variant) {
      let options = Object.entries(variant);
      for (const [key, value] of options) {
        if (value != null) {
          if (optionGroups[key] == undefined) {
            optionGroups[key] = [];
          }
          if (optionGroups[key].includes(value) == false) {
            optionGroups[key].push(value);
          }
        }
      }
    });

    // Then, loop through each input and check if its value is in the optionGroups
    // array created above, ignoring the clicked option group.
    document.querySelectorAll(".js--variant-option").forEach(function(input) {
      if (input.name != $this.name) {
        if (optionGroups[input.name].includes(input.value) == false) {
          input.disabled = true;
        } else {
          input.disabled = false;
        }
      }
    });
  }

  // Check a valid option is selected for each group.
  document.querySelectorAll(".js--variant-options").forEach(function(group) {
    let firstAvailable = null;
    let checkedOptions = group.querySelectorAll('.js--variant-option:checked').length;
    if (checkedOptions == 0) {
      firstAvailable = group.querySelectorAll(".js--variant-option:not(:disabled)")[0];
    }
    if (firstAvailable != null) {
      firstAvailable.checked = true;
      items = getVariants();
    }
  });
  // END.

  // Set availability.
  if (items.variant != null && items.variant.available == true) {
    availability = true;
    btn.disabled = false;
    btn.querySelector('span').innerText = localeStrings.addToCart;
  } else {
    btn.disabled = true;
    btn.querySelector('span').innerText = localeStrings.soldOut;
  }

  // Update SKU.
  if (sku) {
    if (items.variant != null && items.variant.sku) {
      sku.innerHTML = `Product Code: <span class="visually-hidden">SKU:</span> ${items.variant.sku}`;
    } else {
      sku.innerHTML = `Product Code: <span class="visually-hidden">SKU:</span> --`;
    }
  }

  // Display the VAT relief and non-vat relief pricing.
  let prices = "";
  if (activeCurrency == homeCurrency) {
    if (items.exclusiveVariant != null) {
      prices = `
        <span class="product-price-size--h3">${money(items.exclusiveVariant.price)}</span>
        ${localeStrings.vatPriceSuffix}<br>
        Inc. VAT: ${money(items.inclusiveVariant.price)}`;
      if (items.variant.compare_at_price > items.variant.price) {
        prices = `
          <span class="product-price-size--h3">${money(items.exclusiveVariant.price)}</span>
          <strike>${money(items.exclusiveVariant.compare_at_price)}</strike>
          ${localeStrings.vatPriceSuffix}
          <br>
          Inc. VAT: ${money(items.inclusiveVariant.price)}
          <strike>${money(items.inclusiveVariant.compare_at_price)}</strike>`;
      }
      document.querySelectorAll('.js--variant-prices').forEach(function(el) {
        el.innerHTML = prices;
      });
    }
  } else {
    if (items.variant.compare_at_price > items.variant.price) {
      prices = `
        <div class="price__container price price--large">
          <div class="price__regular">
            <span class="visually-hidden visually-hidden--inline">Regular price</span>
            <span class="price-item price-item--regular">${money(items.exclusiveVariant.price)}</span>
            <strike>${money(items.exclusiveVariant.compare_at_price)}</strike>
            <span class="badge color-scheme-3">Sale</span>
          </div>
        </div>`;
    } else {
      prices = `
        <div class="price__container price price--large">
          <div class="price__regular">
            <span class="visually-hidden visually-hidden--inline">Regular price</span>
            <span class="price-item price-item--regular">${money(items.exclusiveVariant.price)}</span>
          </div>
        </div>`;
    }
    document.querySelectorAll('.js--variant-prices').forEach(function(el) {
      el.innerHTML = prices;
    });
  }
}

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('.js--variant-option').forEach(function(el) {
    el.addEventListener('change', function(event) {
      variantAvailability();
    });
  });
  variantAvailability();
});


/*
 * CLEAR CART ATTRIBUTES
 * Deletes the VAT Exempt cart attributes. Here for test purposes.
 */
function clearCartAttributes() {
  return $.ajax({
    type: "post",
    url: "/cart/update.js",
    data: {
      attributes: {
        "VAT Exempt": null,
        "VAT Exempt Reason": null,
      },
    },
    dataType: "json",
    success: function() {
      console.log("Cart attributes cleared.");
      location.reload();
    },
  });
}


/*
 * MONEY FORMAT
 * Formats money in javascript.
 */
function money(value) {
  value = value / 100;
  let string = value.toLocaleString("en-GB", { style: "currency", currency: Shopify.currency.active });
  return string;
}
